export default {
  all: 'All',
  app_disabled: 'We are updating the content, it will be available again shortly',
  autocomplete_placeholder: 'Enter your address or postal code',
  back_to_list: 'Back to the list',
  catalogue_image: 'Catalogue cover',
  catalogue_loading: 'We are loading your catalogue',
  catalogues: 'Catalogues',
  catalogues_in_area: 'Catalogues in the area',
  catalogues_loading: 'Loading',
  catalogues_near_you: 'Catalogues around you',
  catalogues_not_found: 'Currently, there are no catalogues in the area',
  close_catalogues: 'Close',
  close_products: 'Close',
  close_stores: 'Close',
  closed: 'Closed',
  characteristics: 'Features',
  days_of_week: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  description_missing: 'No description available',
  expires: 'Expires',
  expired: 'Expired',
  find_me: 'Find me',
  geolocation_error: 'Attention: the location did not yield any results',
  geolocation_image: 'Geolocation',
  geolocation_info:
    'To show catalogues in your area, we need to know your location. Please enter your address or postal code',
  geolocation_loading: 'We are configuring your location',
  geolocation_missing: 'Update your location to view offers and nearest stores',
  localize_yourself: 'Locate me',
  more_info: 'Discover more',
  next: 'Next',
  not_now: 'Not now',
  of: 'Of',
  open: 'Open',
  open_24_hours: 'Open 24/7',
  or: 'or',
  other_stores: 'Offers available also here',
  page: 'Page',
  previous: 'Previous',
  price: 'Price',
  products: 'Products',
  products_find: 'Search for a product',
  index: 'Index',
  products_list: 'Product list',
  read_all: 'Read all',
  sale: 'Discount',
  search_placeholder: 'What are you looking for?',
  stores: 'Stores',
  understand: 'I understand',
  usergeolocation_label: 'Enter your address to find the best store offers in your area',
  fullscreen: 'Full screen',
  fullscreenExit: 'Reduce screen',
  no_nearest_store_at: 'No store nearby',
  nearest_store_at: 'Nearest store in {distance}',
  nearby_stores: 'Nearby stores',
  show_all_pages: 'View all pages',
  show: 'Show',
  directionVertical: 'Vertical scroll',
  directionHorizontal: 'Horizontal scroll',
  share: 'Share',
  share_with_friends: 'Share with your friends',
  copy_link: 'Copy link',
  sms: 'SMS',
  email: 'Email',
  more_stores: 'more stores',
  stores_within: 'Stores within a radius of {maxDistance}',
  invalid_offers_disclaimer:
    'The offers in this catalogue are not valid in stores near you. Please check another catalogue or locate yourself in another area',
  download_pdf: 'Download PDF',
  flyer_unavailable_error: 'Unable to open this catalogue. Check the link or try again later.',
};
